import { FilteredCommand, MultiselectCommand } from '../../../core/model/command';

export const tenantCommand = {
  cleanupData: 'cleanupData',
  printGDPR: 'printGDPR',
  sendRegistrationKey: 'sendRegistrationKey',
  showInvoices: 'showInvoices',
  showFaultNotification: 'showFaultNotification',
  repayBalance: 'repayBalance',
  moveBalance: 'moveBalance',
  linkDocument: 'linkDocument',
  deleteDocument: 'deleteDocument',
  downloadDocument: 'downloadDocument',
  export: 'export',
};

export const vacantRentalObjectCommand = {
  createContract: 'createLease',
  createBlockContract: 'createBlockLease',
  exportToExcel: 'export',
};

export const rentalObjectFormCommand = {
  createContract: 'createLease',
};
